export default __webpack_public_path__ + "static/media/logo.034ef726.svg";